import { API } from "aws-amplify";

const API_NAME = "LMS_API";
const RELATION_ID = "3ea8f37b-c94b-11e8-a78b-e9151b2d9abc";

export async function Get(path, options) {
  let config = {
    ContentType: 'application/json',
  };
  if (options) {
    config = Object.assign(config, options);
  }
  return await API.get(API_NAME, `${path}`, config);
}

export async function Post(path, data, options = {}) {
  let config = {
    body: {
      ...data
    }
  };
  if (options) {
    config = Object.assign(config, options);
  }
  return await API.post(API_NAME, path, config);
}

export async function Put(path, data, options) {
  let config = {
    body: {
      ...data
    }
  };
  if (options) {
    config = Object.assign(config, options);
  }
  return await API.put(API_NAME, path, config);
}

export async function Delete(path, options) {
  let config = {};
  if (options) {
    config = Object.assign(config, options);
  }
  return await API.del(API_NAME, path, config);
}
